import { createSvgIcon } from '@material-ui/core';

export const RemoteIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.28 36C23.28 33.948 24.948 32.28 27 32.28H31.8V30H27C23.688 30 21 32.688 21 36C21 39.312 23.688 42 27 42H31.8V39.72H27C24.948 39.72 23.28 38.052 23.28 36ZM28.2 37.2H37.8V34.8H28.2V37.2ZM39 30H34.2V32.28H39C41.052 32.28 42.72 33.948 42.72 36C42.72 38.052 41.052 39.72 39 39.72H34.2V42H39C42.312 42 45 39.312 45 36C45 32.688 42.312 30 39 30Z"
      fill="currentColor"
    />
    <path
      d="M4.9519 4.99584C5.5614 4.35821 6.38805 4 7.25 4H20.25L30 14.2V24H26.75V15.9H18.625V7.4H7.25V34.6H18V38H7.25C6.38805 38 5.5614 37.6418 4.9519 37.0042C4.34241 36.3665 4 35.5017 4 34.6V7.4C4 6.49826 4.34241 5.63346 4.9519 4.99584Z"
      fill="currentColor"
    />
    <path d="M18 27.8V31.2H10.5V27.8H18Z" fill="currentColor" />
    <path d="M23.5 24H18V24.4H10.5V21H23.5V24Z" fill="currentColor" />
  </svg>,
  'RemoteIcon',
);
